import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import EditBtnCellRenderer from './editBtnCellRenderer';
import SearchMenu from './searchMenu';
import { getUserRole, getUserDetails } from '../../../../services/common/util';
import { createAudit } from '../../../../services/clinicPortalServices/auditService';
import { auditEnums } from '../../../../services/common/constants';
import { ThemeContext } from '../../../../theme/ThemeProvider';
import { getAllAnalytes } from '../../../../services/clinicPortalServices/analyteService';
import { fetchQcRanges } from '../../../../services/clinicPortalServices/qcRangeService';
import moment from 'moment';
import { colorSchemeDark, colorSchemeLight, themeQuartz } from 'ag-grid-community';

const themeLight = themeQuartz.withPart(colorSchemeLight);
const themeDark = themeQuartz.withPart(colorSchemeDark);

class ClinicAnalyteGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {
            qcRanges: [],
            quickFilterText: '',
            columnDefs: [
                {
                    headerName: 'Actions', colId: 'actions',
                    minWidth: 150,
                    maxWidth: 150,
                    cellStyle: { textAlign: 'center' },
                    cellRenderer: 'editBtnCellRenderer'
                },
                {
                    headerName: 'Name',
                    minWidth: 150,
                    resizable: true,
                    field: 'name'
                },
                {
                    headerName: 'Abbreviation',
                    minWidth: 120,
                    resizable: true,
                    field: 'abbreviation'
                },
                {
                    headerName: 'Loinc Code',
                    minWidth: 150,
                    resizable: true,
                    field: 'loincCode'
                },
                {
                    headerName: 'Units',
                    minWidth: 150,
                    resizable: true,
                    field: 'units'
                },
                {
                    headerName: 'Specimen Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'specimenType'
                },
                {
                    headerName: 'Result Type',
                    minWidth: 150,
                    resizable: true,
                    field: 'resultType'
                },
                // {
                //     headerName: "Reference Ranges",
                //     minWidth: 150,
                //     resizable: true,
                //     field: "referenceRanges"
                // },
                // {
                //     headerName: "Critical Values",
                //     minWidth: 150,
                //     resizable: true,
                //     field: "criticalValues"
                // },
                {
                    headerName: 'Method',
                    minWidth: 150,
                    resizable: true,
                    field: 'method'
                },
                {
                    headerName: 'Instrument',
                    minWidth: 150,
                    resizable: true,
                    field: 'instrument'
                },
                {
                    headerName: 'Medications',
                    minWidth: 150,
                    resizable: true,
                    valueGetter: (params) => {
                        return params.data.medications
                            ? params.data.medications.map((item) => item.name).join(', ')
                            : '';
                    }
                },
                {
                    headerName: 'Turnaround Time',
                    minWidth: 150,
                    resizable: true,
                    field: 'turnaroundTime'
                },
                {
                    headerName: 'Cost',
                    minWidth: 150,
                    resizable: true,
                    field: 'cost'
                },
                {
                    headerName: 'CPT Codes',
                    minWidth: 150,
                    resizable: true,
                    field: 'cptCodes'
                },
                {
                    headerName: 'Clinical Significance',
                    minWidth: 150,
                    resizable: true,
                    field: 'clinicalSignificance'
                },
                {
                    headerName: 'Storage / Transport',
                    minWidth: 150,
                    resizable: true,
                    field: 'storageTransport'
                },
                {
                    headerName: 'Synonyms',
                    minWidth: 150,
                    resizable: true,
                    field: 'synonyms'
                },
                {
                    headerName: 'Interferences',
                    minWidth: 150,
                    resizable: true,
                    field: 'interferences'
                }
            ],
            components: {
                editBtnCellRenderer: EditBtnCellRenderer
            },
            defaultColDef: {
                flex: 1,
                filter: true,
                sortable: true
            },
            rowData: [],
            context: { componentParent: this }
        };
    }

    autoFitActions = (params) => {

        const api = (params && params.api) || this.gridApi;

        if (api && api.autoSizeColumns) setTimeout(() => { try { api.autoSizeColumns(['actions'], false); } catch (e) { /* ignore */ } }, 60);

    };


    onGridReady = (params) => {
        this.gridApi = params.api;

        this.loadGridData();
    };

    loadGridData = () => {
        getAllAnalytes().then((res) => {
            this.setState({ rowData: res.data });
        });
        fetchQcRanges().then((res) => {
            this.setState({ qcRanges: res.data });
        });
    };

    onFilterTextChange = (e) => {
        this.setState({ quickFilterText: e.target.value });
    };

    clearFilter = () => {
        this.gridApi.setFilterModel(null);
        this.setState({ quickFilterText: '' });
        document.getElementById('reset-form').value = '';
    };

    onBtnExport = () => {
        this.gridApi.exportDataAsExcel({
            fileName: 'Analyte_Grid_' + moment().format('YYYY_MM_DD_HH_mm_ss') + '.xlsx',
            sheetName: 'Analytes'
        });
        const userData = JSON.parse(getUserDetails());
        const auditData = {
            identifier: auditEnums.IDENTIFIERS.ExportRecord,
            event_type: auditEnums.EVENTTYPES.AnalyteGridExported,
            user_id: userData._id,
            user_name: userData.user_name + ' (' + userData.role + ')',
            update_string: auditEnums.EVENTTYPES.AnalyteGridExported
        };
        createAudit(auditData);
    };

    render() {
        let columnDefs = /salesperson|audit|salesadmin/.test(getUserRole().toLowerCase())
            ? this.state.columnDefs.filter((x) => x.headerName !== 'Actions')
            : this.state.columnDefs;
        return (
            <div className="clinic-contain">
                <SearchMenu
                    onFilterTextChange={this.onFilterTextChange}
                    clearFilter={this.clearFilter}
                    onBtnExport={this.onBtnExport}
                    context={this.state.context}
                />
                <div
                    style={{
                        width: '100%',
                        height: 'calc(100vh - 250px)',
                        padding: '15px'
                    }}
                >
                    <ThemeContext.Consumer>
                        {({ themeName }) => (
                            <div
                                id="myGrid"
                                style={{
                                    height: '100%',
                                    width: '100%'
                                }}
                            >
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    masterDetail={true}
                                    onGridReady={this.onGridReady}
                                    onFirstDataRendered={this.autoFitActions}
                                    onRowDataUpdated={this.autoFitActions}
                                    rowData={this.state.rowData}
                                    pagination={true}
                                    paginationAutoPageSize={true}
                                    components={this.state.components}
                                    context={this.state.context}
                                    theme={themeName === 'Light' ? themeLight : themeDark}
                                    quickFilterText={this.state.quickFilterText}
                                />
                            </div>
                        )}
                    </ThemeContext.Consumer>
                </div>
            </div>
        );
    }
}

export default ClinicAnalyteGrid;
